export default function toGlobalId(id, type) {
  try {
    return Buffer.from(`${type || ''}:${id || ''}`, 'utf8').toString('base64');
  } catch (e) {
    return '';
  }
}
